/**
 * One settings field, drawn like the Settings page's: a switch for yes/no, an affixed number box
 * otherwise (₱ before pesos; %, km or min after). Shared by Catalogue rules and Zones & fees.
 */
export type RuleKind = 'bool' | 'percent' | 'peso' | 'km' | 'count' | 'minutes' | 'seconds' | 'days';

export function RuleField({ id, kind, label, help, value, error, onChange }: { id: string; kind: RuleKind; label: string; help?: string; value: string | boolean; error?: string; onChange(v: string | boolean): void }) {
  const helpId = `${id}-help`;
  const errId = `${id}-err`;
  const describedBy = [help ? helpId : null, error ? errId : null].filter(Boolean).join(' ') || undefined;
  if (kind === 'bool') {
    return (
      <div className="field">
        <button type="button" role="switch" id={id} className="switch" aria-checked={value === true} aria-describedby={describedBy} onClick={() => onChange(value !== true)}>
          <span className="track" aria-hidden="true" />
          <span className="t-label">{label}</span>
        </button>
        {help ? (
          <span id={helpId} className="help">
            {help}
          </span>
        ) : null}
      </div>
    );
  }
  const prefix = kind === 'peso' ? '₱' : null;
  const suffix = kind === 'percent' ? '%' : kind === 'km' ? 'km' : kind === 'minutes' ? 'min' : kind === 'seconds' ? 'sec' : kind === 'days' ? 'days' : null;
  return (
    <div className="field">
      <label htmlFor={id}>{label}</label>
      <div className="input-affix" data-invalid={error ? 'true' : undefined}>
        {prefix ? (
          <span aria-hidden="true" className="t-mono">
            {prefix}
          </span>
        ) : null}
        <input id={id} inputMode="decimal" autoComplete="off" value={typeof value === 'string' ? value : ''} onChange={(e) => onChange(e.target.value)} aria-invalid={error ? true : undefined} aria-describedby={describedBy} />
        {suffix ? (
          <span aria-hidden="true" className="t-mono muted">
            {suffix}
          </span>
        ) : null}
      </div>
      {help ? (
        <span id={helpId} className="help">
          {help}
        </span>
      ) : null}
      {error ? (
        <span id={errId} className="pill st-error err-pill" style={{ whiteSpace: 'normal' }}>
          {error}
        </span>
      ) : null}
    </div>
  );
}
